/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSettingViewModel } from '../../models/client-setting-view-model';
import { FeatureSettingKeyValueViewModel } from '../../models/feature-setting-key-value-view-model';

export interface SaveClientSettings$Params {
      body?: {
'AAEmail'?: string;
'AcademyLogoPhotoID'?: number;
'AceLogoPhotoID'?: number;
'AceProviderID'?: string;
'AceProviderCoordinator'?: number;
'AuthorizationsEmail'?: string;
'BacbLogoPhotoID'?: number;
'BillingEmail'?: string;
'BusinessAbbreviation'?: string;
'BusinessAddress'?: string;
'BusinessFax'?: string;
'BusinessFullName'?: string;
'BusinessName'?: string;
'BusinessPhone'?: string;
'BusinessWebsite'?: string;
'CareCreditMessage'?: string;
'CareCreditVendor'?: boolean;
'CollectionsWarning'?: string;
'CompanyMedicaidNumber'?: string;
'CompanyNPI'?: string;
'CompanyPTAN'?: string;
'CredentialEmail'?: string;
'DefaultClientIntakeFormID'?: number;
'DefaultFormDueDate'?: number;
'DefaultUserLoginPolicyID'?: number;
'DisplayLogoPhotoID'?: number;
'FromEmailAddress'?: string;
'GoogleCalendarEmail'?: string;
'GoogleCalendarPassword'?: string;
'FirstPayPeriodStartDayOfMonth'?: number;
'ID'?: number;
'ClientID'?: number;
'SiteName'?: string;
'InHouseFinancing'?: boolean;
'InHouseFinancingMessage'?: string;
'IntakeRenewalFrequency'?: number;
'InvoiceReminderFrequencyDays'?: number;
'InvoiceTextReminders'?: boolean;
'NaswLogoPhotoID'?: number;
'OptoMailDomain'?: string;
'PayPeriodFrequencyID'?: number;
'PrintLogoPhotoID'?: number;
'ProfessionalLiabilityAggregateAmount'?: number;
'ProfessionalLiabilityNumber'?: string;
'ProfessionalLiabilityOccurrenceAmount'?: number;
'SMSCollectionsWarning'?: string;
'StartupGuideOn'?: boolean;
'TaxID'?: string;
'TherapyProgressFrequency'?: number;
'UseGoogleCalendar'?: boolean;
'DaysToUnpaidInvoiceServiceInteruption'?: number;
'DaysToUnPaidServiceStop'?: number;
'EmailDisplayName'?: string;
'DaysToFirstScheduleAfterAuth'?: number;
'DaysAfterIncompleteIntakeBlock'?: number;
'EmployeeBenefitInsuranceProviderID'?: number;
'AccountLockedCancellationReasonID'?: number;
'KeyValues'?: Array<FeatureSettingKeyValueViewModel>;
'BillingSettingsName'?: string;
'BillingSettingsAddressLine1'?: string;
'BillingSettingsAddressLine2'?: string;
'BillingSettingsPhoneNumber'?: string;
'BillingSettingsFaxNumber'?: string;
'BillingSettingsEmail'?: string;
'BillingSettingsInvoiceFootnote'?: string;
'DefaultServiceSettingID'?: number;
'BusinessSupportUrl'?: string;
}
}

export function SaveClientSettings(http: HttpClient, rootUrl: string, params?: SaveClientSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSettingViewModel>> {
  const rb = new RequestBuilder(rootUrl, SaveClientSettings.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSettingViewModel>;
    })
  );
}

SaveClientSettings.PATH = '/api/Clients/SaveClientSettings';
